/* eslint-disable no-console */
import { captureException, captureMessage, type SeverityLevel } from "@sentry/react"
import { getPublicConfig } from "@/shared/config/config"
import type { Logger } from "./logger.types"

export const logger: Logger = {
  log: (level: SeverityLevel, message: string, data: unknown) => {
    const timestamp = new Date().toISOString()
    const _formattedMessage = `[${level.toUpperCase()}] ${timestamp} - ${message}`

    switch (level) {
      case "debug":
        if (getPublicConfig().environment === "local") {
          // biome-ignore lint/suspicious/noConsole: Logger needs console for debug output
          console.debug(_formattedMessage, data ?? "")
        }
        break
      case "info":
        // biome-ignore lint/suspicious/noConsole: Logger needs console for info output
        console.info(_formattedMessage, data ?? "")
        captureMessage(message, level)
        break
      case "warning":
        // biome-ignore lint/suspicious/noConsole: Logger needs console for warning output
        console.warn(_formattedMessage, data ?? "")
        captureMessage(message, level)
        break
      case "error":
        // biome-ignore lint/suspicious/noConsole: Logger needs console for error output
        console.error(_formattedMessage, data ?? "")
        captureException(data)
        break
    }
  },
  debug: (message, data) => {
    logger.log("debug", message, data)
  },
  info: (message, data) => {
    logger.log("info", message, data)
  },
  warn: (message, data) => {
    logger.log("warning", message, data)
  },
  error: (message, error) => {
    logger.log("error", message, error)
  }
}
